
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { lambda_type, unit_type, int32_type, float64_type, record_type, class_type, bool_type, option_type, list_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { StocktakingListDto_$reflection, StocktakingDetailDto_$reflection, CreateStocktakingListConsumableResultDto_$reflection, CreateStocktakingListToolWithQuantityResultDto_$reflection, CreateStocktakingListToolResultDto_$reflection, StocktakingResultType, StocktakingResultType_$reflection } from "../../Shared/Stocktaking.js";
import { RequestedValue$1_$reflection, StocktakingListId_$reflection, StocktakingId_$reflection, ValidationResponse_$reflection, ClientApiResponse$1_$reflection, ConsumableId_$reflection, ToolId_$reflection, FormState_get_empty, FormState_$reflection, ConsumableId__get_unwrap, ToolId__get_unwrap } from "../../Shared/Shared.js";
import { map, append } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Helper_unitToTranslationKey } from "../../Shared/Consumable.js";
import { ChangelogDto_$reflection } from "../../Shared/Changelog.js";

export class SelectedTab extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["OpenTasks", "AllRows", "Changelog"];
    }
}

export function SelectedTab_$reflection() {
    return union_type("Stocktaking.StocktakingList.Types.SelectedTab", [], SelectedTab, () => [[], [], []]);
}

export class StocktakingListTableRow extends Record {
    constructor(ImageUrl, InventoryNumber, Unit, Name, Manufacturer, Model, SerialNumber, QRCodeIds, StorageSpace, Quantity, RecordedBy, RecordedViaEmailLink, RecordTimestamp, RecordedQuantity, CorrectedBy, CorrectionTimestamp, CorrectionQuantity, StocktakingResultType) {
        super();
        this.ImageUrl = ImageUrl;
        this.InventoryNumber = InventoryNumber;
        this.Unit = Unit;
        this.Name = Name;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.SerialNumber = SerialNumber;
        this.QRCodeIds = QRCodeIds;
        this.StorageSpace = StorageSpace;
        this.Quantity = Quantity;
        this.RecordedBy = RecordedBy;
        this.RecordedViaEmailLink = RecordedViaEmailLink;
        this.RecordTimestamp = RecordTimestamp;
        this.RecordedQuantity = RecordedQuantity;
        this.CorrectedBy = CorrectedBy;
        this.CorrectionTimestamp = CorrectionTimestamp;
        this.CorrectionQuantity = CorrectionQuantity;
        this.StocktakingResultType = StocktakingResultType;
    }
}

export function StocktakingListTableRow_$reflection() {
    return record_type("Stocktaking.StocktakingList.Types.StocktakingListTableRow", [], StocktakingListTableRow, () => [["ImageUrl", string_type], ["InventoryNumber", string_type], ["Unit", string_type], ["Name", string_type], ["Manufacturer", string_type], ["Model", string_type], ["SerialNumber", string_type], ["QRCodeIds", list_type(string_type)], ["StorageSpace", string_type], ["Quantity", string_type], ["RecordedBy", option_type(string_type)], ["RecordedViaEmailLink", bool_type], ["RecordTimestamp", option_type(class_type("System.DateTime"))], ["RecordedQuantity", option_type(string_type)], ["CorrectedBy", option_type(string_type)], ["CorrectionTimestamp", option_type(class_type("System.DateTime"))], ["CorrectionQuantity", option_type(string_type)], ["StocktakingResultType", StocktakingResultType_$reflection()]]);
}

export class CountingFilter extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["OpenPositions", "AllPositions"];
    }
}

export function CountingFilter_$reflection() {
    return union_type("Stocktaking.StocktakingList.Types.CountingFilter", [], CountingFilter, () => [[], []]);
}

export class CountingResultValue extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Found", "Counted"];
    }
}

export function CountingResultValue_$reflection() {
    return union_type("Stocktaking.StocktakingList.Types.CountingResultValue", [], CountingResultValue, () => [[["Item", bool_type]], [["Item", float64_type]]]);
}

export class CountingResult extends Record {
    constructor(Value, RecordedBy, ViaEmailLink, Timestamp) {
        super();
        this.Value = Value;
        this.RecordedBy = RecordedBy;
        this.ViaEmailLink = ViaEmailLink;
        this.Timestamp = Timestamp;
    }
}

export function CountingResult_$reflection() {
    return record_type("Stocktaking.StocktakingList.Types.CountingResult", [], CountingResult, () => [["Value", CountingResultValue_$reflection()], ["RecordedBy", string_type], ["ViaEmailLink", bool_type], ["Timestamp", class_type("System.DateTime")]]);
}

export class CountingPosition extends Record {
    constructor(ResultType, Name, InventoryNumber, SerialNumber, QRCodeIds, StorageSpace, ImageUrl, ExpectedQuantity, UnitTranslationKey, Result) {
        super();
        this.ResultType = ResultType;
        this.Name = Name;
        this.InventoryNumber = InventoryNumber;
        this.SerialNumber = SerialNumber;
        this.QRCodeIds = QRCodeIds;
        this.StorageSpace = StorageSpace;
        this.ImageUrl = ImageUrl;
        this.ExpectedQuantity = ExpectedQuantity;
        this.UnitTranslationKey = UnitTranslationKey;
        this.Result = Result;
    }
}

export function CountingPosition_$reflection() {
    return record_type("Stocktaking.StocktakingList.Types.CountingPosition", [], CountingPosition, () => [["ResultType", StocktakingResultType_$reflection()], ["Name", string_type], ["InventoryNumber", string_type], ["SerialNumber", string_type], ["QRCodeIds", list_type(string_type)], ["StorageSpace", string_type], ["ImageUrl", string_type], ["ExpectedQuantity", option_type(float64_type)], ["UnitTranslationKey", option_type(string_type)], ["Result", option_type(CountingResult_$reflection())]]);
}

export function positionKey(resultType) {
    switch (resultType.tag) {
        case 1:
            return ToolId__get_unwrap(resultType.fields[0]);
        case 2:
            return ConsumableId__get_unwrap(resultType.fields[0]);
        default:
            return ToolId__get_unwrap(resultType.fields[0]);
    }
}

export function toCountingPositions(stocktakingList) {
    return append(map((tool) => (new CountingPosition(new StocktakingResultType(0, [tool.ToolId]), tool.DisplayName, tool.InventoryNumber, tool.SerialNumber, tool.QRCodeIds, tool.StorageSpace, tool.ImageUrl, undefined, undefined, map_1((result) => (new CountingResult(new CountingResultValue(0, [result.Existing]), result.RecordedBy, result.RecordedViaEmailLink, result.Timestamp)), tool.Result))), stocktakingList.Tools), append(map((tool_1) => (new CountingPosition(new StocktakingResultType(1, [tool_1.ToolId]), tool_1.DisplayName, tool_1.InventoryNumber, "", tool_1.QRCodeIds, tool_1.StorageSpace, tool_1.ImageUrl, tool_1.Quantity, Helper_unitToTranslationKey("piece"), map_1((result_1) => (new CountingResult(new CountingResultValue(1, [result_1.Quantity]), result_1.RecordedBy, result_1.RecordedViaEmailLink, result_1.Timestamp)), tool_1.Result))), stocktakingList.ToolsWithQuantity), map((consumable) => (new CountingPosition(new StocktakingResultType(2, [consumable.ConsumableId]), consumable.ConsumableName, consumable.InventoryNumber, "", consumable.QRCodeIds, consumable.StorageSpace, consumable.ImageUrl, consumable.Quantity, Helper_unitToTranslationKey(consumable.Unit), map_1((result_2) => (new CountingResult(new CountingResultValue(1, [result_2.Quantity]), result_2.RecordedBy, result_2.RecordedViaEmailLink, result_2.Timestamp)), consumable.Result))), stocktakingList.Consumables)));
}

export class CountingState extends Record {
    constructor(CountingFilter, FormState) {
        super();
        this.CountingFilter = CountingFilter;
        this.FormState = FormState;
    }
}

export function CountingState_$reflection() {
    return record_type("Stocktaking.StocktakingList.Types.CountingState", [], CountingState, () => [["CountingFilter", CountingFilter_$reflection()], ["FormState", FormState_$reflection()]]);
}

export const CountingStateModule_empty = new CountingState(new CountingFilter(0, []), FormState_get_empty());

export class CountingMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetCountingFilter", "RecordToolResult", "RecordToolWithQuantityResult", "RecordConsumableResult", "RemoveResult", "ResultRecorded", "CountingFailed"];
    }
}

export function CountingMsg_$reflection() {
    return union_type("Stocktaking.StocktakingList.Types.CountingMsg", [], CountingMsg, () => [[["Item", CountingFilter_$reflection()]], [["Item1", ToolId_$reflection()], ["Item2", bool_type]], [["Item1", ToolId_$reflection()], ["Item2", int32_type]], [["Item1", ConsumableId_$reflection()], ["Item2", float64_type]], [["Item", StocktakingResultType_$reflection()]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

export class CountingRequests extends Record {
    constructor(RecordTool, RecordToolWithQuantity, RecordConsumable, RemoveTool, RemoveToolWithQuantity, RemoveConsumable) {
        super();
        this.RecordTool = RecordTool;
        this.RecordToolWithQuantity = RecordToolWithQuantity;
        this.RecordConsumable = RecordConsumable;
        this.RemoveTool = RemoveTool;
        this.RemoveToolWithQuantity = RemoveToolWithQuantity;
        this.RemoveConsumable = RemoveConsumable;
    }
}

export function CountingRequests_$reflection() {
    return record_type("Stocktaking.StocktakingList.Types.CountingRequests", [], CountingRequests, () => [["RecordTool", lambda_type(ToolId_$reflection(), lambda_type(CreateStocktakingListToolResultDto_$reflection(), list_type(lambda_type(lambda_type(CountingMsg_$reflection(), unit_type), unit_type))))], ["RecordToolWithQuantity", lambda_type(ToolId_$reflection(), lambda_type(CreateStocktakingListToolWithQuantityResultDto_$reflection(), list_type(lambda_type(lambda_type(CountingMsg_$reflection(), unit_type), unit_type))))], ["RecordConsumable", lambda_type(ConsumableId_$reflection(), lambda_type(CreateStocktakingListConsumableResultDto_$reflection(), list_type(lambda_type(lambda_type(CountingMsg_$reflection(), unit_type), unit_type))))], ["RemoveTool", lambda_type(ToolId_$reflection(), list_type(lambda_type(lambda_type(CountingMsg_$reflection(), unit_type), unit_type)))], ["RemoveToolWithQuantity", lambda_type(ToolId_$reflection(), list_type(lambda_type(lambda_type(CountingMsg_$reflection(), unit_type), unit_type)))], ["RemoveConsumable", lambda_type(ConsumableId_$reflection(), list_type(lambda_type(lambda_type(CountingMsg_$reflection(), unit_type), unit_type)))]]);
}

export class CountingEvent extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Recorded", "Rejected", "Failed"];
    }
}

export function CountingEvent_$reflection() {
    return union_type("Stocktaking.StocktakingList.Types.CountingEvent", [], CountingEvent, () => [[], [["Item", ValidationResponse_$reflection()]], [["Item", class_type("System.Exception")]]]);
}

export class DialogOpenState extends Record {
    constructor(IsConfirmationStateStartDialogOpen, IsConfirmationStateDoneDialogOpen) {
        super();
        this.IsConfirmationStateStartDialogOpen = IsConfirmationStateStartDialogOpen;
        this.IsConfirmationStateDoneDialogOpen = IsConfirmationStateDoneDialogOpen;
    }
}

export function DialogOpenState_$reflection() {
    return record_type("Stocktaking.StocktakingList.Types.DialogOpenState", [], DialogOpenState, () => [["IsConfirmationStateStartDialogOpen", bool_type], ["IsConfirmationStateDoneDialogOpen", bool_type]]);
}

export class State extends Record {
    constructor(StocktakingId, StocktakingListId, Stocktaking, StocktakingList, Changelogs, DialogOpenState, Counting, FormState) {
        super();
        this.StocktakingId = StocktakingId;
        this.StocktakingListId = StocktakingListId;
        this.Stocktaking = Stocktaking;
        this.StocktakingList = StocktakingList;
        this.Changelogs = Changelogs;
        this.DialogOpenState = DialogOpenState;
        this.Counting = Counting;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("Stocktaking.StocktakingList.Types.State", [], State, () => [["StocktakingId", StocktakingId_$reflection()], ["StocktakingListId", StocktakingListId_$reflection()], ["Stocktaking", RequestedValue$1_$reflection(StocktakingDetailDto_$reflection())], ["StocktakingList", RequestedValue$1_$reflection(StocktakingListDto_$reflection())], ["Changelogs", RequestedValue$1_$reflection(list_type(ChangelogDto_$reflection()))], ["DialogOpenState", DialogOpenState_$reflection()], ["Counting", CountingState_$reflection()], ["FormState", FormState_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FetchStocktaking", "FetchChangelogs", "StocktakingFetched", "SetStocktakingStateStart", "SetStocktakingStateDone", "OnCloseConfirmationStateStartDialog", "OnCloseConfirmationStateDoneDialog", "StocktakingStateSet", "ChangelogsFetched", "ChangelogsFetchFailed", "Counting", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Stocktaking.StocktakingList.Types.Msg", [], Msg, () => [[], [], [["Item", StocktakingDetailDto_$reflection()]], [], [], [["Item", bool_type]], [["Item", bool_type]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", list_type(ChangelogDto_$reflection())]], [["Item", class_type("System.Exception")]], [["Item", CountingMsg_$reflection()]], [["Item", class_type("System.Exception")]]]);
}

